import React, {useEffect, useRef, useState} from "react";
import st from "@/styles/LoginPage.module.scss";
import {useTranslation} from "react-i18next";
import ChevroneIcon from "@/svg/ChevronIocn.tsx";
import Button from "@/ui/Button.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import { useNavigate,  } from 'react-router-dom';
import {useAtom} from "jotai";
import {login_data, profile} from "@/atoms/profile.ts";
import LoginData from "@/types_and_interfaces/login_data.ts";
import LoginLoader from "@/ui/LoginLoader.tsx";
import clsx from "clsx";
import {profile_api} from "@/services/account.ts";
import useAuth from "@/hooks/auth.ts";
import CommonClass from "@/utils/common.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import WritePwdFields from "@/ui/WritePwdFields.tsx";
import {pwd_value} from "@/atoms/common.ts";
import {getDeviceUUID} from "@/utils/export_functions.ts";


const StepThreeForm:React.FC = ({}) => {
    const {t} = useTranslation()
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);

    const formRef = useRef<any>(null)

    const [loginData] = useAtom(login_data)
    const [, setUser] = useAtom(profile)
    const [pwd_fields] = useAtom(pwd_value);
    const [loaded, setloaded] = useState<boolean>(false)
    const [reqLoad, setReqLoad] = useState<boolean>(false)
    const [, setError] = useState(false)

    const uid = getDeviceUUID() || ""
    const auth = useAuth()

    const debug = queryParams.get("debug")
    const userId = sessionStorage.getItem(CommonClass.local_storage_fields.check_phone_data);
    const user_id = userId ? JSON.parse(userId) : null;
    const data:LoginData = Boolean(loginData) ?  JSON.parse(loginData) : {}

    const loadedHandler = () => {
        if(Object.keys(data).length && data.hasOwnProperty("interval") && typeof data !== undefined){
            setloaded(true)
        }
    }

    const submitForm = async (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        

        const pwd = pwd_fields.join("")
        
        if(typeof pwd === "string") {
            
            if(pwd.length < 4) {
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("pin_condition"))
                
                return
            }
            
            setReqLoad(true)

            let r_token:string | undefined  = undefined
            if(CommonClass.general_settings.recaptcha.is_enabled) {
                r_token = await auth.getRecaptchaToken()
            }
            
            let req = await profile_api().set_pwd(pwd, r_token)
            
            if(req?.status === 400) {
                setError(true)
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("error_message"))
                setReqLoad(false)
                return
            }
            
            if(req?.status === 500) {
                setError(true)
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("error_message"))
                setReqLoad(false)
                return
            }
            
            if(req?.status === 429) {
                setError(true)
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("att_limit"))
                setReqLoad(false)
                return
            }
            
            if(req?.status === 200 && req?.response.hasOwnProperty("message") && req.response.message === "ok") {
                
                let timeout = setTimeout(async () => {
                    if(debug === "true") console.info("setInterval StepThreeForm")
                    if(uid) {
                        await auth.auth(pwd, user_id)
                        setReqLoad(false)
                    }
                    clearTimeout(timeout)
                }, 500)
                

            }
        }
    }
    
    useEffect(() => {
        loadedHandler()
    }, [loginData]);
    
    useEffect(() => {
        const timeout = setTimeout(() => {
            if(debug === "true") console.info("setInterval StepThreeForm")
            if((typeof loginData === "string" && loginData.length === 0) || typeof loginData === "undefined" || loginData === null) {
                navigate(DashboardClass.login_routes.LoginStep1)
            }
        }, 3000)
        
        return () => {
            clearTimeout(timeout)
        }
    }, []);
    
    useEffect(() => {
        if(pwd_fields.length === 4) {
            let completed = true
            
            pwd_fields.map((x) => {
                if(x === "" || x === " ") {
                    completed = false
                }
                
            })
            
            if(completed && formRef.current) {
                formRef.current.requestSubmit()
            }
        }
    }, [pwd_fields]);
    
    return loaded &&  (
        <div className={st.log_vars}>
            <form className={st.other_steps} ref={formRef} onSubmit={submitForm}>
                
                <div className={st.top}>
                    
                    <div className={st.heading}>
                        {t("set_pin")}
                        
                        <div className={st.info}>
                            <span className={st.inf_text}>
                                {t("pin_condition")}
                            </span>
                        </div>
                    
                    </div>
                    
                    <div className={st.form_core}>
                        {/*<PasswordInput/>*/}
                        <WritePwdFields className={st.pwd}/>
                    </div>
                    
                    <div className={clsx(st.bottom, st.nowrap)}>
                        <Button
                            className={st.back}
                            onClick={() => {
                                setUser(undefined)
                                localStorage.removeItem(CommonClass.local_storage_fields.session_token)
                                navigate(DashboardClass.login_routes.LoginStep1)
                            }}
                            type={"button"}
                            outlined
                        >
                            <ChevroneIcon/>
                            
                            {t("back")}
                        
                        </Button>
                        
                        <Button
                            className={st.go_on}
                            type={"button"}
                            outlined
                            onClick={() => {
                                navigate(DashboardClass.dashboard_routes.Home)
                            }}
                        >
                            
                            {t("go_on_without_pin")}
                        
                        </Button>
                        
                        {/*<Button type={"submit"} animated className={st.auth_btn}>*/}
                        {/*    <span>*/}
                        {/*        {t("set")}*/}
                        {/*    </span>*/}
                        {/*</Button>*/}
                    
                    </div>
                
                </div>
                
                

                
                
                {reqLoad && <LoginLoader/>}
            
            </form>
        </div>
    
    )
}


export default StepThreeForm